import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type { SupplierListItem, SupplierMaterial } from "../types/types.ts"
import type {
  BulkSupplierMaterialsData,
  BulkSupplierMaterialsErrors,
  BulkSupplierMaterialsSummary,
  CreateSupplierData,
  CreateSupplierMaterialData,
  GetSupplierMaterialsParams,
  GetSuppliersParams,
  UpdateSupplierData,
  UpdateSupplierMaterialData
} from "./services.types.ts"

const BASE_URL = "/supplier/suppliers"

// Flat rather than nested under the supplier: the endpoint scopes itself with
// a required `?supplier=`, and the finance tab reads the same route.
const MATERIALS_URL = "/supplier/materials"

export const getSuppliers = (params?: GetSuppliersParams) =>
  request.api.get<BasePagination<SupplierListItem>, BaseApiResponse<unknown>>(
    `${BASE_URL}/`,
    params
  )

export const getSupplierDetails = (id: string) =>
  request.api.get<SupplierListItem, BaseApiResponse<unknown>>(
    `${BASE_URL}/${id}/`
  )

export const createSupplier = (data: CreateSupplierData) =>
  request.api.post<BaseApiResponse<SupplierListItem>, BaseApiResponse<unknown>>(
    `${BASE_URL}/`,
    data
  )

export const updateSupplier = ({ id, ...rest }: UpdateSupplierData) =>
  request.api.patch<
    BaseApiResponse<SupplierListItem>,
    BaseApiResponse<unknown>
  >(`${BASE_URL}/${id}/`, rest)

export const deleteSupplier = (id: string) =>
  request.api.delete<BaseApiResponse<null>, BaseApiResponse<unknown>>(
    `${BASE_URL}/${id}/`
  )

export const getSupplierMaterials = (params: GetSupplierMaterialsParams) =>
  request.api.get<BasePagination<SupplierMaterial>, BaseApiResponse<unknown>>(
    `${MATERIALS_URL}/`,
    params
  )

export const createSupplierMaterial = (data: CreateSupplierMaterialData) =>
  request.api.post<BaseApiResponse<SupplierMaterial>, BaseApiResponse<unknown>>(
    `${MATERIALS_URL}/`,
    data
  )

export const updateSupplierMaterial = ({
  id,
  ...rest
}: UpdateSupplierMaterialData) =>
  request.api.patch<
    BaseApiResponse<SupplierMaterial>,
    BaseApiResponse<unknown>
  >(`${MATERIALS_URL}/${id}/`, rest)

export const deleteSupplierMaterial = (id: string) =>
  request.api.delete<BaseApiResponse<null>, BaseApiResponse<unknown>>(
    `${MATERIALS_URL}/${id}/`
  )

export const bulkUpsertSupplierMaterials = (data: BulkSupplierMaterialsData) =>
  request.api.post<
    BaseApiResponse<BulkSupplierMaterialsSummary>,
    BulkSupplierMaterialsErrors
  >(`${MATERIALS_URL}/bulk/`, data)
